import { useCallback, useEffect, useState } from "react";
import { LoxSettings } from "./types";
import { loadSettings, saveSettings } from "./settingsStorage";

export function useSettings() {
  const [settings, setSettings] = useState<LoxSettings | null>(null);
  const [saving, setSaving] = useState(false);

  // Roaming settings are available synchronously once Office is ready.
  useEffect(() => {
    setSettings(loadSettings());
  }, []);

  const update = useCallback(<K extends keyof LoxSettings>(key: K, value: LoxSettings[K]) => {
    setSettings((prev) => (prev ? { ...prev, [key]: value } : prev));
  }, []);

  const save = useCallback(async (): Promise<void> => {
    if (!settings) return;
    setSaving(true);
    try {
      await saveSettings(settings);
    } finally {
      setSaving(false);
    }
  }, [settings]);

  return { settings, update, save, saving };
}
